/**
 * useParentAuth — separate file so the ParentAuthProvider module
 * remains component-only-export-friendly for Fast Refresh (oxlint's
 * `react/only-export-components` rule).
 */
import { useContext } from 'react';
import {
  ParentAuthContext,
  type ParentAuthContextValue,
} from './ParentAuthContext';

export function useParentAuth(): ParentAuthContextValue {
  const ctx = useContext(ParentAuthContext);
  if (!ctx) {
    throw new Error('useParentAuth must be used within a <ParentAuthProvider>.');
  }
  return ctx;
}
